import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import image from '../../assets/images/banner/hero.jpg';
import logo from '../../assets/images/logo-full.svg';
import BannerText from '../common/bannerText';

const Section = Styled.section.attrs((props) => ({ id: 'banner' }))`
padding: 4rem 0;
min-height: 100vh;
background: ${
  image ? `url(${image}) no-repeat center center/cover` : color.primary
};
display: grid;
grid-template-columns: repeat(2, 1fr);
@media only screen and (max-width:700px){
min-height: 80rem;
grid-template-columns: repeat(1, 1fr);};
background: ${
  image ? `url(${image}) no-repeat center left/cover` : color.primary
};
}
`;

const Logo = Styled.div`
height: 100%;
width: 100%;
background-color:transparent;
display: flex;
flex-direction: column;
align-items:center;
justify-content: space-between;
@media only screen and (max-width:700px){display: none;};
`;

const LogoLink = Styled.a.attrs(({ href }) => ({ href }))`
display: block;
width: 20rem;
img{width: 100%;}
`;

const Paragraph = Styled.p`
color:${color.white};
`;

const Banner = () => {
  return (
    <Section>
      <Logo>
        <LogoLink href="/">
          <img src={logo} alt="" />
        </LogoLink>
        <Paragraph>Ozzie in Brooklyn</Paragraph>
      </Logo>
      <BannerText />
    </Section>
  );
};

export default Banner;
